import type { ComponentProps, ReactNode } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface SimpleTooltipProps extends ComponentProps<typeof TooltipTrigger> {
  description: ReactNode;
  tooltipContentProps?: ComponentProps<typeof TooltipContent>;
}

/**
 * Bir qatorlik tooltip: `Root` + `Trigger` + `Content` ni o'zi yig'adi,
 * sahifa faqat matnni beradi (brb-workspace'dagi `SimpleTooltip`).
 *
 * Provider alohida kerak emas — `ui/tooltip` dagi `Tooltip` uni o'zi olib
 * keladi. Nomi ataylab `Tooltip` emas: `ui/tooltip` da shu nomli quyi
 * qatlam komponenti bor va ikkalasi bir xil atalsa, avtoto'ldirish ularni
 * aralashtirib yuboradi.
 */
export const SimpleTooltip = ({
  children,
  description,
  tooltipContentProps,
  ...props
}: SimpleTooltipProps) => (
  <Tooltip>
    <TooltipTrigger asChild {...props}>
      {children}
    </TooltipTrigger>
    <TooltipContent {...tooltipContentProps} className="max-w-96">
      {description}
    </TooltipContent>
  </Tooltip>
);
